import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-upload-trading-partner',
  templateUrl: './upload-trading-partner.component.html',
  styleUrls: ['./upload-trading-partner.component.scss'],
})
export class UploadTradingPartnerComponent implements OnInit {
  myFiles: any[];
  maxQuantity: number;
  maxSize: number;
  currentQuantity: number;
  currentSize: number;

  constructor(
    public dialogRef: MatDialogRef<UploadTradingPartnerComponent>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.myFiles = [];
    this.maxQuantity = this.data.maxQuantity;
    this.maxSize = this.data.maxSize;
    this.currentSize = 0;
    this.currentQuantity = 0;
  }

  closeDialog(value: any = null) {
    this.dialogRef.close(value);
  }

  handleFiles(input) {
    if (input && input.files && input.files.length > 0)
      Array.from(input.files).forEach((element: File) => {
        // Check if file is already in the list
        if (
          this.myFiles.filter(function (e) {
            return e.name === element.name;
          }).length > 0
        ) {
          this.toastr.error(
            'The file: ' +
              element.name +
              ' already exists. Duplicates not allowed. ',
            'Service Error'
          );
          return;
        }
        // Check if the list is full
        if (this.myFiles.length >= this.maxQuantity) {
          this.toastr.error(
            'The file: ' +
              element.name +
              ' exceeds the maximum number of files ',
            'Service Error'
          );
          return;
        }
        // Check if the file exceeds the total size for attachments
        if (element.size >= this.maxSize - this.currentSize) {
          this.toastr.error(
            'The file: ' + element.name + ' exceeds the total limit allowed ',
            'Service Error'
          );
          return;
        } else {
          this.myFiles.push(element);
          this.currentSize += element.size;
          this.currentQuantity++;
        }
      }, this);
  }

  onDrop($event) {
    $event.preventDefault();
    const files = $event.dataTransfer.files;

    if (files && files.length > 0) {
      Array.from(files).forEach((element: File) => {
        // Check if file is already in the list
        if (
          this.myFiles.filter(function (e) {
            return e.name === element.name;
          }).length > 0
        ) {
          this.toastr.error(
            'The file: ' +
              element.name +
              ' already exists. Duplicates not allowed. ',
            'Service Error'
          );
          return;
        }
        // Check if the list is full
        if (this.myFiles.length >= this.maxQuantity) {
          this.toastr.error(
            'The file: ' +
              element.name +
              ' exceeds the maximum number of files ',
            'Service Error'
          );
          return;
        }
        // Check if the file exceeds the total size for attachments
        if (element.size >= this.maxSize - this.currentSize) {
          this.toastr.error(
            'The file: ' + element.name + ' exceeds the total limit allowed ',
            'Service Error'
          );
          return;
        } else {
          this.myFiles.push(element);
          this.currentSize += element.size;
          this.currentQuantity++;
        }
      }, this);
    }
  }

  onDragOver($event) {
    $event.stopPropagation();
    $event.preventDefault();
  }

  removeFile(file) {
    if (file) {
      this.myFiles.splice(
        this.myFiles.findIndex((item) => item.name === file.name),
        1
      );
      this.currentSize -= file.size;
      this.currentQuantity--;
    }
  }

  submit() {
    this.closeDialog(this.myFiles);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/upload-trading-partner/upload-trading-partner.component.ts